var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSport = function SvgSport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pingpong"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ping-ball",
    d: "M21.6157 30.31C23.4472 30.31 24.9318 28.8253 24.9318 26.9938C24.9318 25.1624 23.4472 23.6777 21.6157 23.6777C19.7842 23.6777 18.2996 25.1624 18.2996 26.9938C18.2996 28.8253 19.7842 30.31 21.6157 30.31Z",
    fill: "#FFA656"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.156 10.9689L19.0676 12.6499L8.64541 30.7016L5.73384 29.0206L16.156 10.9689Z",
    fill: "#EBE0CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M16.8784 22.7302C22.3727 22.7302 26.8268 18.2761 26.8268 12.7817C26.8268 7.28738 22.3727 2.83331 16.8784 2.83331C11.384 2.83331 6.92993 7.28738 6.92993 12.7817C6.92993 18.2761 11.384 22.7302 16.8784 22.7302Z",
    fill: "#CE553A"
  })))));
};
export default SvgSport;